<template>
  <div class="widget-add box--shadow" :class="{'text-white btn-white': background}" :style="{ backgroundImage: 'url(' + background + ')' }">
    <div class="row">
        <!--<div class="col-12 col-sm-5 col-md-6 col-lg-5 col-xl-6 widget-add-img" v-if="image">-->
          <!--&lt;!&ndash;<img :src="image" />&ndash;&gt;-->
        <!--</div>-->
        <div class="widget-add-content" v-bind:class="colClass">
            <h2 :class="{'text-white': background}" class="text-center" v-html="title"></h2>
            <p>{{body}}</p>
            <p v-if="to" class="text-center"><a :href="to" class="btn btn-primary ">{{callToAction}}</a></p>
            <p v-if="!to" class="text-center"><button class="btn btn-primary" v-on:click="$emit('onClick')">{{callToAction}}</button></p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetAdd',
  props: ['background', 'image', 'title', 'body', 'callToAction', 'to', 'textAlign'],
  computed: {
    colClass: function () {
      if (this.textAlign === 'LEFT') {
        return 'col-12 col-sm-8 col-md-7 col-lg-8 col-xl-7'
      } else if (this.textAlign === 'RIGHT') {
        return 'col-12 col-sm-8 offset-sm-5 col-md-7 offset-md-6 col-lg-8 offset-lg-5 col-xl-7 offset-xl-6 '
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .widget-add{
    background-color: white;
    background-size: cover;
    background-position: center;
    padding: 1.5rem 2rem;
    border: 5px solid white;
    display: flex;
    align-items: center;
    height:100%;
    min-height:180px;
    border-radius:4px;
  }

  .widget-add-img {
      position:relative;
      display:flex;
      align-content:center;
      align-items:center;
      justify-content:center;
      padding-top:0.5rem;
      padding-bottom:1.5rem;

      img {
          width:100%;
          height:auto;
          max-width:200px;
      }

      @media (min-width:576px) {
          position:absolute;
          display:flex;
          align-content:center;
          align-items:center;
          left:0px;
          top:50%;
          transform:translateY(-50%);
          padding-top:0;
          padding-bottom:0;

          img {
              max-width:100%;
          }
      }
  }

  .widget-add-content {
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      justify-content:flex-start;

      > * {
          width:100%;
      }

      p:nth-last-of-type(1) {
          margin-bottom:0;
      }
  }

  p {
      color: #00193D;
  }

  .text-white p {
      color: white;
  }

  h2{
      font-family: Athelas;
      font-size: 28px;
      font-weight: bold;
      line-height: 27px;
      margin: 0 0 0.5rem 0;
  }
  img{
      display: block;
      width: 100%;
  }

  .btn {
      width:auto !important;
      display:inline-block;

      @media (min-width:992px) {
          min-width: 200px;
      }
  }

  .btn-primary {
      color: white !important;
  }

  .btn-white .btn-primary {
      /*background-color: #E6E6E6;*/
      /*border: 1px solid #E6E6E6;*/
      /*color: #778598 !important;*/

      &:hover, &:active, &:focus {
          color: #778598 !important;
          background: white;
          border-color:white;
      }
  }

  .row{
      width: 100%;
  }

</style>
 


// WEBPACK FOOTER //
// src/components/widgets/WidgetAdd.vue